import { Component } from "@angular/core";

@Component({
  selector: "[sk-media-contact]",
  templateUrl: "./media-contact.component.html",
  styleUrls: ["./media-contact.component.css"]
})
export class MediaContactComponent {
  linkedInUrl = "https://www.linkedin.com/in/sasi-kumar-manickam";
  gitHubUrl = "https://github.com/mskkai";
  stackOverflowUrl = "https://stackoverflow.com/users/1994646/sasi-kumar-m";
  youTubeUrl = "https://www.youtube.com/channel/UCKYDSThooowKXLASdUs7GpA";
}
